import React from "react";

const STYLES = {
  PENDING: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  AVAILABLE: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  USED: "bg-slate-500/10 text-slate-400 border-slate-500/30",
  REVERSED: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  CANCELLED: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  REVIEW: "bg-indigo-500/10 text-indigo-300 border-indigo-500/30",
  ACTIVE: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  REQUESTED: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  PAID: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  REJECTED: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  PENDING_KYC: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  VERIFIED: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  BLOCKED: "bg-rose-500/10 text-rose-400 border-rose-500/30",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || "bg-slate-500/10 text-slate-400 border-slate-500/30";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-mono font-medium tracking-wide ${cls}`}
    >
      {status}
    </span>
  );
}
